<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <h3 class="center">Applying status {{selectedStatus | splitCamelCase}}...</h3>
</ng-template>

<ng-template #generalButton>
  <button mat-flat-button color="primary" disabled>
    Change Status
  </button>
</ng-template>


<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="3%">

  <h1 matDialogTitle>
    This box needs your attention!
  </h1>
  <mat-dialog-content class="overflow-hidden">
    <ng-container *ngIf="!saving else loadingGeneral">
      <aw-general-item-detail-dialog fxFlexAlign="stretch" [inputData]="_box"
        [disableCloseButton]="true"></aw-general-item-detail-dialog>
    </ng-container>
  </mat-dialog-content>


  <mat-form-field>
    <mat-label>Select Status</mat-label>
    <mat-select [(value)]="selectedStatus">
      <mat-option *ngFor="let status of statuses" [value]="status">
        {{status | splitCamelCase}}
      </mat-option>
    </mat-select>
  </mat-form-field>



  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button *ngIf="selectedStatus else generalButton" mat-flat-button color="primary" (click)="setStatus()"
      [disabled]="saving">
      Apply Status "{{selectedStatus | splitCamelCase}}"
    </button>
    <button mat-button matDialogClose>CLOSE</button>
  </mat-dialog-actions>
</div>